import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("twss_admin_token") || ""}`,
});

export const adminApi = {
  login: (email, password) =>
    axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data),
  me: () => axios.get(`${API}/auth/me`, { headers: authHeaders() }).then((r) => r.data),
  get: (p) => axios.get(`${API}/admin${p}`, { headers: authHeaders() }).then((r) => r.data),
  post: (p, d) => axios.post(`${API}/admin${p}`, d, { headers: authHeaders() }).then((r) => r.data),
  put: (p, d) => axios.put(`${API}/admin${p}`, d, { headers: authHeaders() }).then((r) => r.data),
  del: (p) => axios.delete(`${API}/admin${p}`, { headers: authHeaders() }).then((r) => r.data),
  getBlob: (p) =>
    axios
      .get(`${API}/admin${p}`, { headers: authHeaders(), responseType: "blob" })
      .then((r) => r.data),
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
